if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super()

      this.form = this.querySelector('form')
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
      this.miniCart = document.getElementById('mini-cart')
      this.headerCartCount = document.getElementById('cart-icon-bubble').querySelector('span:first-child').childNodes[1];
    }

    getSectionsToRender() {
      return [
        {
          id: 'mini-cart',
          section: document.getElementById('mini-cart').dataset.id,
          selector: '.js-contents',
        },
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: '.shopify-section',
        },
      ]
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML
    }

    onSubmitHandler(evt) {
      evt.preventDefault()

      const submitButton = this.querySelector('[type="submit"]')
      const statusBlock = document.querySelector('product-totals')

      submitButton.setAttribute('disabled', true)
      submitButton.classList.add('loading')
      const body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
      })

      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.text())
        .then((state) => {
          const parsedState = JSON.parse(state)

          const cartItems = window.__CART__.items
          let alreadyInCart = false
          if (cartItems.length) {
            window.__CART__.items.map((item) => {
              if (item.id === parsedState.id) {
                item.quantity = parsedState.quantity
                alreadyInCart = true
              }
            })
          }
          if (!alreadyInCart) {
            window.__CART__.items.push(parsedState)
          }

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document
                .getElementById(section.id)
                .querySelector(section.selector) ||
              document.getElementById(section.id)
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            )
          })

          document.getElementById('cart-icon-bubble').classList.add('open-by-adding')
          document.getElementById('cart-icon-bubble').click()
        })
        .catch((e) => {
          console.error(e)
        })
        .finally(() => {
          submitButton.classList.remove('loading')
          submitButton.removeAttribute('disabled')
          statusBlock?.updateText(JSON.parse(body)?.quantity)
          fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then(data => {
              this.headerCartCount.nodeValue = data.item_count;
            })
            .catch((e) => {
              console.error(e)
            });
        })
    }
  }

  customElements.define('product-form', ProductForm)
}
